/// <amd-module name="Tfs/Frame/Util/Navigation" />
import { getDeviceType } from "Tfs/Platform/DeviceType";
import { ScreenSize } from "VSS/Core/Util/Screen";
import { IVssPageContext } from "VSS/Platform/Context";

export const useFlyoutNavigation = (pageContext: IVssPageContext, screenSize: ScreenSize): boolean => {
    // Use the hamburger/flyout version of the navigation if EITHER:
    // 1. The screen width is very narrow OR
    // 2. We've detected this as a phone device (mobile, non-tablet, based on user agent strings)
    // For the second condition, since user agent string detection is not 100% safe, also ensure that the device width
    // is not large. If the screen width is larger than any reasonable phone can go, then consider this NOT to be a phone
    return screenSize === ScreenSize.xsmall || (screenSize <= ScreenSize.medium && getDeviceType(pageContext).phone);
};
